<template>
    <v-card>
        <v-card-title>
            <v-flex xs12 sm6>
                <div class="headline">Gerar termos de publicização</div>
            </v-flex>
        </v-card-title>
        <v-card-title>
            <exam-filters v-model="filters" :options="['semester','course']" />
        </v-card-title>

        <v-card-title v-if="errors != false">
            <v-alert color="error" value="true" v-for="(error, idx) in errors" :key="'error_'+idx">
                {{ error }}
            </v-alert>
        </v-card-title>
    </v-card>
</template>

<script>
import ExamFilters from './ExamFilters.vue';

export default {
    components: {
        ExamFilters
    },
    data() {
        return {
            filters: {
                course: '',
                semester: '',
                view: 'view_all',
            },
            errors: false
        };
    },
    watch: {
        'filters.course': function (newValue) {
            this.errors = false;
            this.genTokenAndDownload(newValue, this.filters.semester);
        },
        'filters.semester': function () {
            this.filters.course = ''; // Reseta o curso ao alterar o semestre
        }
    },
    methods: {
        genTokenAndDownload(course, semester) {
            this.$http.post('createTermsDocument', { semester, course }).then(response => {
                if (response.data.token) {
                    document.token = response.data.token;
                    this.download(document);
                } else {
                    // console.error('Não foi possível gerar o documento');
                    // console.debug(response);
                    this.errors = response.data.errors
                }
            }, response => {
                // console.error('Não foi possível gerar o documento');
                // console.debug(response);
                this.errors = response.data.errors
            });
        },
        download: function (document) {
            let url = this.$http.options.root + 'documentos.php?token=' + document.token
            this.openURL(url)
        },
        openURL: function (url) {
            window.open(url, '_blank')
        },
    }
}
</script>

<style>
.no-padding {
    padding: 0 !important;
    margin: 0 !important;
}

.studentName {
    font-size: 10px;
    margin-top: 5px !important;
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// ExamTerms.vue?41dc17f8